import { render, staticRenderFns } from "./wearables.vue?vue&type=template&id=39be4d2b&scoped=true&"
import script from "./wearables.vue?vue&type=script&lang=js&"
export * from "./wearables.vue?vue&type=script&lang=js&"
import style0 from "./wearables.vue?vue&type=style&index=0&id=39be4d2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39be4d2b",
  null
  
)

component.options.__file = "wearables.vue"
export default component.exports